"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThingImage1Schema = void 0;
exports.ThingImage1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/thing-link/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ThingImage1",
    "description": "Embed an image from a Thing",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:thing-link:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "imageId": {
                    "type": "string",
                    "description": "Thing image"
                }
            },
            "required": [
                "imageId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy90aGluZy1saW5rLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsaUJBQWlCLEdBQUc7SUFDL0IsS0FBSyxFQUFFLCtFQUErRTtJQUN0RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxhQUFhO0lBQ3RCLGFBQWEsRUFBRSw2QkFBNkI7SUFDNUMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHVDQUF1QzthQUN4QztTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsWUFBWSxFQUFFO2dCQUNaLFNBQVMsRUFBRTtvQkFDVCxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLGFBQWE7aUJBQzdCO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsU0FBUzthQUNWO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=